import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import { withTranslation, Trans } from 'react-i18next'
import { exteriorView10ImageOptions } from './views/ExteriorView10'

class Xr41Mainsail extends Component {
  constructor (props) {
    super(props)
    this.handleMainsailChange = this.handleMainsailChange.bind(this)
  }

  handleMainsailChange (newValue) {
    let configuration = this.props.configuration
    configuration.Mainsail = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

	render() {
		let imageOptions = exteriorView10ImageOptions;

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Mainsail' />
          </h1>

          <p>
            <Trans defaults='The Race version setup could feature a square-top mainsail, split backstay and a larger sailarea, tailored for full-crew competitive sailing. ' />
          </p>

		            <p>
            <Trans defaults='The Sport version can come with a pinhead mainsail, single backstay, and a slightly reduced sail plan, offering easier handling and greater simplicity – ideal for shorthanded or family sailing.
' />
          </p>

          <RadioGroup
            label={this.props.t('Mainsail options:')}
            options={this.props.mainsailOptions}
            value={this.props.configuration.Mainsail}
            onChange={this.handleMainsailChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Mainsail)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Mainsail.js